module.exports = __webpack_public_path__ + "fonts/pfbenchmarkpro-bolditalic.3be6de1.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/pfbenchmarkpro/pfbenchmarkpro-bolditalic.woff
// module id = 168
// module chunks = 245 246